<template>
    <!-- Games section start -->
    <section id="gallery" class="px-12 lg:px-32 py-16 relative overflow-hidden max-width-container">
        <!-- Text wrapper start -->
        <div class="mb-8">
            <!-- Main text start -->
            <h1 class="uppercase text-3xl mb-4 font-semibold">Galéria</h1>
            <p class="text-stone-500 mb-8 text-justify">
                Fedezd fel galériánkat, ahol megtekintheted eddigi munkáink legjobb pillanatait, amelyek örömet
                szereztek kicsiknek és nagyoknak egyaránt. Inspiráló képeink bemutatják, hogyan hozunk össze
                közösségeket, és teremtünk felejthetetlen élményeket.

                <strong>Sokak számára ezek az események jelentették az első lépést a mászás világába,</strong> és azóta
                is boldogan térnek vissza hozzánk. Nézd meg, hogyan válhat egy egyszerű pillanat életre szóló emlékké,
                és csatlakozz te is azokhoz, akik már megtapasztalták, milyen különleges élményeket kínálunk!
            </p>
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Masonry grid start -->
        <div class="columns-2 md:columns-5 gap-4 mb-8">
            <div v-for="(image, index) in images" :key="index" class="break-inside-avoid mb-4">
                <img :src="image.src" :alt="image.alt" :title="image.title" class="rounded-xl object-cover w-full">
            </div>
        </div>
        <!-- Masonry grid end -->

        <!-- "More" link start -->
        <!-- <a href="#" class="text-end">
            <p class="font-semibold text-lg group relative">
                <span>További képek </span>
                <i class="fa-solid fa-arrow-right"></i>
            </p>
        </a> -->
        <!-- "More" link end -->

        <!-- Circle start -->
        <div class="bg-neutral-300 h-64 w-64 rounded-full absolute top-0 left-0 mt-16 -z-20"></div>
        <!-- Circle end -->
    </section>
    <!-- Portfolio section end -->
</template>

<script>
export default {
    data() {
        return {
            images: [
                {
                    src: require("@/assets/images/gallery/galeria-01.webp"),
                    alt: "Galéria kép 1",
                    title: "Galéria kép 1",
                    keywords: "mászás, galéria, élmény"
                },
                {
                    src: require("@/assets/images/gallery/galeria-02.webp"),
                    alt: "Galéria kép 2",
                    title: "Galéria kép 2",
                    keywords: "mászás, galéria, közösség"
                },
                {
                    src: require("@/assets/images/gallery/galeria-03.webp"),
                    alt: "Galéria kép 3",
                    title: "Galéria kép 3",
                    keywords: "mászás, galéria, sport"
                },
                {
                    src: require("@/assets/images/gallery/galeria-04.webp"),
                    alt: "Galéria kép 4",
                    title: "Galéria kép 4",
                    keywords: "mászás, galéria, szórakozás"
                },
                {
                    src: require("@/assets/images/gallery/galeria-05.webp"),
                    alt: "Galéria kép 5",
                    title: "Galéria kép 5",
                    keywords: "mászás, galéria, család"
                },
                {
                    src: require("@/assets/images/gallery/galeria-06.webp"),
                    alt: "Galéria kép 6",
                    title: "Galéria kép 6",
                    keywords: "mászás, galéria, barátok"
                },
                {
                    src: require("@/assets/images/gallery/galeria-07.webp"),
                    alt: "Galéria kép 7",
                    title: "Galéria kép 7",
                    keywords: "mászás, galéria, kihívás"
                },
                {
                    src: require("@/assets/images/gallery/galeria-08.webp"),
                    alt: "Galéria kép 8",
                    title: "Galéria kép 8",
                    keywords: "mászás, galéria, kaland"
                },
                {
                    src: require("@/assets/images/gallery/galeria-09.webp"),
                    alt: "Galéria kép 9",
                    title: "Galéria kép 9",
                    keywords: "mászás, galéria, természet"
                },
                {
                    src: require("@/assets/images/gallery/galeria-10.webp"),
                    alt: "Galéria kép 10",
                    title: "Galéria kép 10",
                    keywords: "mászás, galéria, élmény"
                },
                {
                    src: require("@/assets/images/gallery/galeria-11.webp"),
                    alt: "Galéria kép 11",
                    title: "Galéria kép 11",
                    keywords: "mászás, galéria, sport"
                },
                {
                    src: require("@/assets/images/gallery/galeria-12.webp"),
                    alt: "Galéria kép 12",
                    title: "Galéria kép 12",
                    keywords: "mászás, galéria, szórakozás"
                },
                {
                    src: require("@/assets/images/gallery/galeria-13.webp"),
                    alt: "Galéria kép 13",
                    title: "Galéria kép 13",
                    keywords: "mászás, galéria, közösség"
                },
                {
                    src: require("@/assets/images/gallery/galeria-14.webp"),
                    alt: "Galéria kép 14",
                    title: "Galéria kép 14",
                    keywords: "mászás, galéria, család"
                },
                {
                    src: require("@/assets/images/gallery/galeria-15.webp"),
                    alt: "Galéria kép 15",
                    title: "Galéria kép 15",
                    keywords: "mászás, galéria, barátok"
                },
                {
                    src: require("@/assets/images/gallery/galeria-16.webp"),
                    alt: "Galéria kép 16",
                    title: "Galéria kép 16",
                    keywords: "mászás, galéria, kihívás"
                },
                {
                    src: require("@/assets/images/gallery/galeria-17.webp"),
                    alt: "Galéria kép 17",
                    title: "Galéria kép 17",
                    keywords: "mászás, galéria, kaland"
                },
                {
                    src: require("@/assets/images/gallery/galeria-18.webp"),
                    alt: "Galéria kép 18",
                    title: "Galéria kép 18",
                    keywords: "mászás, galéria, természet"
                },
                {
                    src: require("@/assets/images/gallery/galeria-19.webp"),
                    alt: "Galéria kép 19",
                    title: "Galéria kép 19",
                    keywords: "mászás, galéria, élmény"
                },
                {
                    src: require("@/assets/images/gallery/galeria-20.webp"),
                    alt: "Galéria kép 20",
                    title: "Galéria kép 20",
                    keywords: "mászás, galéria, sport"
                }
            ]
        };
    }
};
</script>

<style></style>
